module.exports = __webpack_public_path__ + "img/full7-min.d7ce3b06.png";